<template>
  <ag-modal-container
    title="Types d'opération supprimées"
    width="900px"
    @close="back"
  >
    <div
      v-if="!loadingData && !operationTypeList.length"
      class="text-center title mt-5"
    >
      Aucun élément
    </div>

    <operation-type-list
      v-else
      :value="operationTypeList"
      :selected.sync="selectedOperationTypeList"
      :loading="loadingData"
      light
    />

    <template v-slot:footer>
      <v-spacer />
      <ag-confirm-dialog
        title="Confirmation"
        :message="restoreMessage"
        cancel-label="Annuler"
        confirm-label="Restaurer"
        validation-btn-color="accent"
        @confirm="restoreSelected"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :loading="loadingRestore"
            :disabled="!selectedOperationTypeList.length || loadingRestore"
            color="accent"
            class="ml-5"
            v-bind="attrs"
            v-on="on"
            v-text="'Restaurer'"
          />
        </template>
      </ag-confirm-dialog>
    </template>
  </ag-modal-container>
</template>

<script>
import { mapActions } from 'vuex'
import Repositories from 'src/repositories'

import AgModalContainer from 'src/components/common/AgModalContainer'
import AgConfirmDialog from 'src/components/common/AgConfirmDialog'
import OperationTypeList from '../components/OperationTypeList'

export default {
  name: 'OperationTypeRestoreContainer',
  components: {
    AgModalContainer,
    AgConfirmDialog,
    OperationTypeList,
  },
  data () {
    return {
      operationTypeList: [],
      selectedOperationTypeList: [],
      loadingData: false,
      loadingRestore: false,
    }
  },
  computed: {
    restoreMessage () {
      const count = this.selectedOperationTypeList.length
      return `Souhaitez-vous restaurer ${count} type(s) d'opération(s)`
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler ({ name }) {
        if (name === 'OperationTypeRestore') {
          this.fetchData()
        }
      },
    },
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    back () {
      this.$router.back()
    },
    async fetchData () {
      this.loadingData = true
      this.operationTypeList = await Repositories.operationType.getList({ archived: true })
      this.loadingData = false
    },
    async restoreSelected () {
      try {
        this.loadingRestore = true
        const count = this.selectedOperationTypeList.length
        await Repositories.operationType.restore(
          this.selectedOperationTypeList.map(select => select._id),
        )

        this.selectedOperationTypeList = []
        this.fetchData()

        this.showSuccessNotification(`Vous avez restoré ${count} type(s) d'opération(s)`)
      }
      catch (error) {
        this.showErrorNotification(Repositories.parseErrorMessage(error))
      }
      finally {
        this.loadingRestore = false
      }
    },
  },
}
</script>
